export default "__VITE_ASSET__hPN00IPE__"